import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import Grid from "@material-ui/core/Grid";
import Image from "../../../assets";
import CustomButton from "../CustomButton";
import Modal from "@material-ui/core/Modal";
import CustomPaper from "../CustomPaper";
import Color from "../../../utils/Color";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import LoadingOverlay from "../LoadingOverlay";

function getModalStyle(isOverFlowVisible) {
  const top = 51;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    overflow: isOverFlowVisible ? "visible" : false,
  };
}

function getMobileModalStyle(isOverFlowVisible) {
  const top = 42;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top + 8}%, -${left}%)`,
    overflow: isOverFlowVisible ? "visible" : false,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    overflow: "scroll",
    display: "block",
    outline: "none",
    [theme.breakpoints.up("sm")]: {
      minWidth: 580,
      maxHeight: 630,
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: 270,
      marginTop: 20,
      marginBottom: 20,
      maxHeight: 500,
    },
    paddingLeft: 25,
    paddingRight: 15,
    paddingBottom: 25,
    "&:focus": {
      outline: "none",
    },
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "grey",
      //opacity:0.5
      //outline: '1px solid slategrey'
    },
  },
  paperLoading: {
    position: "absolute",
    overflow: "hidden",
    display: "block",
    [theme.breakpoints.up("sm")]: {
      minWidth: 580,
      maxHeight: 550,
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: 300,
      marginTop: 20,
      marginBottom: 20,
      maxHeight: 500,
    },
    paddingLeft: 25,
    paddingRight: 10,
    paddingBottom: 25,
    "&:focus": {
      outline: "none",
    },
  },
  modalTitleStyle: {
    fontSize: "18px",
    ...getFontWeight("800"),
    paddingLeft: 0,
    display: "inline-block",
  },
  buttonTextStyle: {
    paddingRight: 20,
    paddingLeft: 20,
    // minWidth: 80,
    // marginLeft: 10,
    // marginRight: 15,
  },
  cancelButtonTextStyle: {
    paddingRight: 20,
    paddingLeft: 20,
    // marginLeft: 10,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    border: "1px solid",
    borderRadius: 8,
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
  },
  closeButtonStyle: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  borderStyle: {
    border: "solid 1px",
    padding: 12,
  },
  //  paperFullWidth: {
  //   overflowY: 'visible'
  // },
}));

const CustomModalV2 = ({
  open,
  handleClose,
  modalTitle,
  titlestyle,
  modalComponent,
  submitButtonText,
  handleSubmitButton,
  cancelButtonText,
  handleCancelButton,
  isVisibleCloseButton = true,
  disableBackdropClick = false,
  loading,
  modalDesign,
  isOverFlowVisible,
  allowBorder = false,
  isTitleCenter,
  buttonStyle,
  confirmCenter,
  isWhiteCloseIcon,
  ...props
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

  const [modalStyle] = React.useState(getModalStyle(isOverFlowVisible));
  const [mobileModalStyle] = React.useState(
    getMobileModalStyle(isOverFlowVisible)
  );

  const body = (
    <CustomPaper
      design={
        loading
          ? `${classes.paperLoading} ${modalDesign}`
          : `${classes.paper} ${modalDesign}`
      }
      style={matchesXS ? mobileModalStyle : modalStyle}
      //style={{overflow:"visible"}}
    >
      <div className={allowBorder ? classes.borderStyle : null}>
        <Grid container>
          {isVisibleCloseButton ? (
            <Grid item xs={12}>
              <Grid container justify={"flex-end"}>
                <img
                  src={isWhiteCloseIcon ? Image.clearWhite : Image.clear_icon}
                  onClick={handleClose}
                  className={classes.closeButtonStyle}
                />
              </Grid>
            </Grid>
          ) : (
            false
          )}
          <Grid
            container
            style={
              isVisibleCloseButton
                ? { marginBottom: modalTitle ? 30 : 0 }
                : { paddingTop: 10 }
            }
          >
            <Grid
              item
              xs={12}
              style={{ textAlign: isTitleCenter ? "center" : false }}
            >
              <CustomText design={`${classes.modalTitleStyle} ${titlestyle}`}>
                {modalTitle}
              </CustomText>
            </Grid>
          </Grid>
        </Grid>
        <div style={{ marginRight: isVisibleCloseButton ? 30 : 0 }}>
          {modalComponent}
        </div>
        <Grid
          container
          spacing={2}
          style={buttonStyle ? buttonStyle : { marginBottom: 0 }}
          justify={confirmCenter ? "center" : undefined}
        >
          {submitButtonText ? (
            <Grid item>
              <CustomButton
                title={submitButtonText}
                design={classes.buttonTextStyle}
                onClick={handleSubmitButton}
              />
            </Grid>
          ) : (
            false
          )}

          {cancelButtonText ? (
            <Grid item>
              <CustomButton
                title={cancelButtonText}
                design={classes.cancelButtonTextStyle}
                onClick={handleCancelButton}
              />
            </Grid>
          ) : (
            false
          )}
        </Grid>
      </div>
    </CustomPaper>
  );

  return (
    <Grid>
      <Modal
        disablePortal
        open={open}
        onClose={handleClose}
        disableBackdropClick={disableBackdropClick}
        classes={{
          paperFullWidth: classes.paperFullWidth,
        }}
      >
        <div>
          {loading ? <LoadingOverlay loading={true} /> : false}
          {body}
        </div>
      </Modal>
    </Grid>
  );
};

export default CustomModalV2;
